<div class="p-4">
    <div class="bg-neutral-400 h-1 w-full rounded-md"></div>
    <div class="p-4">
        <slot></slot>
    </div>
    <div class="bg-neutral-400 h-1 w-full rounded-md"></div>
</div>
